import React, { useState, useEffect, useMemo, useContext } from 'react'
import Grid from '@mui/material/Grid2'
import { borderColor, borderRadius, display, padding, styled, width } from '@mui/system'
import { Button, Box, Typography, Divider, Pagination, Stack, TextField, Select, MenuItem } from '@mui/material'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import arrow_detail from '../../../asset/arrow_detail.png'
import { DataGrid } from '@mui/x-data-grid'
import TablePagination from '@mui/material/TablePagination'
import Api from '../../../Api/Api'

import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import { DataContext } from '../../../Context/LocDataContext'
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table'

const styles1 = {
  Typography1: {
    color: '#ffffff',
    fontFamily: 'Noto Sans KR',
    fontSize: '22px',
    fontWeight: 700,
    lineHeight: '28.96px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  Typography2: {
    color: '#d0d0d0',
    fontFamily: 'Noto Sans KR',
    fontSize: '22px',
    lineHeight: '28.96px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  grid2: {
    backdropFilter: 'blur(53px)',
    boxShadow: '-8px 4px 5px 0px #0000003d',
    borderRadius: '5px',
    background:
      'linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14)),linear-gradient(321.23deg, rgba(191, 191, 191, 0.062) 15.98%, rgba(0, 0, 0, 0) 36.28%)',
    border: '1px solid #afafaf',
    borderImageSource:
      'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
  },
  Box1: {
    border: '0.5px solid #FFFFFF',
    borderRadius: '6px',
    width: 323,
    height: 50,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: 1.5,
  },
  button1: {
    borderRadius: '6px',
    background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
  },
  InputTextField1: {
    width: '100%',
    height: 54,
    borderRadius: 12,
  },

  TableCell1: {
    color: '#CCCCCC',
    borderBottom: '1px solid #CCCCCC',
    background:
      'linear-gradient(to bottom, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
  },
  Select1: {
    '& label': {
      color: '#e4e4e7',
    },
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      opacity: 0.8,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      borderWidth: '1px',
      opacity: 0.8,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      borderWidth: '1px',
    },
    '& .MuiSvgIcon-root': {
      color: '#ffffff',
    },
    '& .MuiInputBase-input': {
      color: '#ffffff',
    },
    '&:hover .MuiInputBase-input': {
      borderColor: '#afafaf',
      borderWidth: '1px',
      opacity: 0.8,
    },
    '&.Mui-focused .MuiInputBase-input': {
      borderColor: '#afafaf',
      borderWidth: '1px',
    },

    color: '#ffffff',
    backdropFilter: 'blur(53px)',
    boxShadow: '-8px 4px 5px 0px #0000003d',
    background: '#171821',
    // border: '1px solid #afafaf',
    // borderImageSource:
    //   'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
  },

  TableCellHeader1: { background: '#2F2E41', color: '#ffffff', borderBottom: '1px solid #CCCCCC' },

  DataGrid1: {
    color: '#ffffff',
    '& .MuiDataGrid-cellContent': {
      minHeight: 25,
      maxHeight: 25,
    },
    '& .super-app-theme--header': {
      backgroundColor: '#000000',
    },
    //MuiDataGrid-cell
    '& .MuiDataGrid-row': {
      backgroundColor: '#CCCCCC',
    },
    '& .MuiDataGrid-row.Mui-selected': {
      backgroundColor: '#CCCCCC',
    },

    '& .MuiToolbar-root': {
      background: '#000000',
      color: '#ffffff',
    },
    '& .MuiSvgIcon-root': {
      color: '#ffffff',
    },
    '&, [class^=MuiDataGrid]': { borderRadius: 0 },
    '& .MuiButton-text': {
      color: '#ffffff',
    },
    '& .MuiDataGrid-filler': {
      backgroundColor: '#B7B6B6',
    },

    '& .MuiDataGrid-columnHeaderTitleContainer': {
      background: '#000000',
    },
    '& .MuiDataGrid-cell': {
      background:
        'linear-gradient(to bottom, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
    },

    '& .MuiDataGrid-footerContainer': {
      backgroundColor: '#000000',
    },
  },
}

const InputTextField = styled(TextField)({
  '& label': {
    // placeholder text color
    color: '#BCBDC4',
  },
  '& label.Mui-focused': {
    // 해당 input focus 되었을 때 placeholder text color
    // floatng label을 사용할 때 처리 필요하다
    color: '#BCBDC4',
  },

  '& label.Mui-error': {
    color: '#d32f2f',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#ffffff',
    borderWidth: '0.15rem',
  },
  '& .MuiOutlinedInput-root': {
    color: '#ffffff',
    '& fieldset': {
      borderColor: '#BCBDC4',
    },
  },
})

//"User", "Worker", "Device", "Facility"
export default function GroupManage(props) {
  console.log('GroupManage props:', props)
  const { inputOrgid, inputLoid, setInputOrgid, setInputLoid } = useContext(DataContext)

  const [newGroupFlag, setNewGroupFlag] = useState(false)
  const [modifyGroupFlag, setModifyGroupFlag] = useState(false)
  const [groupList, setGroupList] = useState([])
  const [rowDetail, setRowDetail] = useState()
  const [inputGroupName, setInputGroupName] = useState('')
  const [inputGroupCategory, setInputGroupCategory] = useState('')
  const [inputGroupType, setInputGroupType] = useState('Device')
  const [inputGroupMid, setInputGroupMid] = useState([])
  const [locationInfo, setLocationInfo] = useState([])

  const [inputGroupCategoryModify, setInputGroupCategoryModify] = useState('')
  const [inputGroupMidModify, setInputGroupMidModify] = useState([])

  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))

  //초기화면 진입시 최상단 스크롤
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const columnsDevice = [
    { field: 'dsi', headerName: '장비유형', headerClassName: 'super-app-theme--header', flex: 1 },
    {
      field: 'dname',
      headerName: '장비명',
      headerClassName: 'super-app-theme--header',
      flex: 1,
    },

    // {
    //   field: 'age',
    //   headerName: 'Age',
    //   type: 'number',
    //   width: 110,
    //   editable: true,
    // },
    // {
    //   field: 'fullName',
    //   headerName: 'Full name',
    //   description: 'This column has a value getter and is not sortable.',
    //   sortable: false,
    //   width: 160,
    //   valueGetter: (params) => `${params.row.firstName || ''} ${params.row.lastName || ''}`,
    // },
  ]

  const columns = useMemo(
    () => [
      {
        accessorKey: 'grp_name',
        header: '그룹명',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'grp_type',
        header: '타입',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'lon',
        header: '시설명',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'mid_count',
        header: '그룹맴버수',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'ct',
        header: '생성일자',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
    ],
    []
  )

  //   <TableRow
  //   key={index}
  //   sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
  //   onClick={() => {
  //     handleModifyGroupFlagFalse()
  //     setRowDetail(row)
  //   }}
  // >

  const table = useMantineReactTable({
    columns: columns,
    data: groupList, //must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    getRowId: (row) => row.ji,
    // onRowSelectionChange: setRowSelection,
    // state: { rowSelection },
    // selectDisplayMode: 'checkbox',
    // enableRowSelection: true,
    // enableMultiRowSelection: true,
    enableColumnActions: false,
    enableColumnFilters: false,
    enablePagination: true,
    enableSorting: false,
    enableFullScreenToggle: false,
    paginationDisplayMode: 'pages',
    initialState: { density: 'sm' },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: (event) => {
        handleModifyGroupFlagFalse()
        setRowDetail(row.original)
      },
      sx: {
        cursor: 'pointer', //you might want to change the cursor too when adding an onClick
      },
    }),
    mantineTableHeadCellProps: {
      sx: { background: '#2F2E41' },
      align: 'center',
      // '.mantine-TableHeadCell-Content-Wrapper': {
      //   color: '#ffffff',
      // },
      ' .mantine-TableHeadCell-Content-Labels .mantine-TableHeadCell-Content-Wrapper': {
        color: '#ffffff',
      },
    },
    mantineTableBodyCellProps: {
      sx: {
        color: '#CCCCCC',
        background:
          'linear-gradient(to bottom, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
      },
      align: 'center',
    },
    mantineDetailPanelProps: {
      sx: {
        color: '#ffffff',
        background:
          'linear-gradient(to right, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
      },
    },
    mantineTopToolbarProps: {
      sx: {
        color: '#ffffff',
        background: '#21222D',
        // mantine-Stack-root
        '.mantine-Alert-root': {
          color: '#ffffff',
          background: '#21222D',
        },
        '.mantine-Stack-root': {
          color: '#ffffff',
          background: '#21222D',
        },
      },
    },
    mantineBottomToolbarProps: {
      sx: {
        background: '#21222D',
        '.mantine-Input-input': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
        '.mantine-InputWrapper-label': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
        '& .mantine-Text-root': {
          color: '#ffffff',
        },
      },
    },
    mantinePaginationProps: {
      sx: {
        background: '#21222D',
        '.mantine-UnstyledButton-root': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
      },
    },
  })

  const handleNewGroupFlagTrue = () => {
    if (props.data === '') {
      alert('시설이 선택되지 않았습니다.')
    } else {
      setNewGroupFlag(true)
    }
  }

  const handleModifyGroupFlagTrue = () => {
    if (props.data === '') {
      alert('시설이 선택되지 않았습니다.')
    } else {
      setInputGroupCategoryModify(rowDetail.grp_category)
      setInputGroupMidModify(rowDetail.mid)
      setModifyGroupFlag(true)
    }
  }
  const handleNewGroupFlagFalse = () => {
    setInputGroupName('')
    setInputGroupCategory('')
    setInputGroupType('Device')
    setInputGroupMid([])
    setNewGroupFlag(false)
  }

  const handleModifyGroupFlagFalse = () => {
    setInputGroupCategoryModify('')
    setInputGroupMidModify([])
    setModifyGroupFlag(false)
  }

  //유효성검사
  const validation = (param) => {
    let check = /[~!@#$%^&*()_+|<>?:{}.,/;='"ㄱ-ㅎ | ㅏ-ㅣ |가-힣]/
    return check.test(param)
  }
  //유효성검사 후 그룹이름 넣기
  const handleInputGroupName = (e) => {
    if (validation(e.target.value)) {
      alert('한글이나 특수문자는 입력 할 수 없습니다.')
    }
    const values = e.target.value.replace(/\s+/g, '')
    const result = values.replace(/[^A-Za-z0-9]/gi, '')
    setInputGroupName(result)
  }

  const handleInputGroupCategory = (e) => {
    const values = e.target.value
    setInputGroupCategory(values)
  }

  const handleInputGroupCategoryModify = (e) => {
    const values = e.target.value
    setInputGroupCategoryModify(values)
  }

  const handleInputGroupType = (e) => {
    const values = e.target.value
    setInputGroupType(values)
  }

  useEffect(() => {
    // getGroupListTotal()
    getLocationInfo()
  }, [])

  useEffect(() => {
    getGroupListByLocation()
    getLocationInfo()
  }, [props.data])

  const [pg, setpg] = React.useState(0)
  const [rpg, setrpg] = React.useState(5)

  function handleChangePage(event, newpage) {
    setpg(newpage)
  }
  function handleChangeRowsPerPage(event) {
    setrpg(parseInt(event.target.value, 10))
    setpg(0)
  }

  // const getGroupListTotal = async () => {
  //   try {
  //     const response = await Api.get('/api/v1/grp')
  //     // const response = await Api.get('/api/v1/orgn', {
  //     //   withCredentials: true,
  //     // })
  //     if (response.status === 200) {
  //       setGroupList(response.data)
  //     }
  //     console.log('getGroupListTotal response.data:', response.data)
  //   } catch (e) {
  //     console.log('Users exception', e)
  //   }
  // }

  const getGroupListByLocation = async () => {
    try {
      const response = await Api.get(`api/v1/grp/get_grp/by_loid?grp_loid=${props.data}`)
      // const response = await Api.get('/api/v1/orgn', {
      //   withCredentials: true,
      // })
      if (response.status === 200) {
        setGroupList(response.data)
        setRowDetail(response.data[0])
      }
      console.log('getGroupListByLocation response.data:', response.data)
    } catch (e) {
      console.log('getGroupListByLocation exception', e)
    }
  }

  const getLocationInfo = async () => {
    try {
      const response = await Api.get(`/api/v1/loca/${props.data}`)
      // const response = await Api.get('/api/v1/orgn', {
      //   withCredentials: true,
      // })
      if (response.status === 200) {
        const resData = response.data
        const result = JSON.parse(resData.dvloc)
        setLocationInfo(result)
        console.log('getLocationInfo result:', result)
      }
      console.log('getLocationInfo response.data:', response.data)
    } catch (e) {
      console.log('getLocationInfo exception', e)
    }
  }
  // mark
  const deleteGroup = async () => {
    if (window.confirm('선택 그룹을 삭제 하시겠습니까?')) {
      if (rowDetail !== undefined && rowDetail !== null && rowDetail !== '') {
        const tempObject = {
          grp_name: rowDetail.grp_name,
          grp_type: rowDetail.grp_type,
          grp_loid: rowDetail.grp_loid,
        }
        console.log('deleteGroup tempObject:', tempObject)
        try {
          const response = await Api.delete(
            `/api/v1/grp/?grp_name=${rowDetail.grp_name}&grp_type=${rowDetail.grp_type}&grp_loid=${rowDetail.grp_loid}`
          )

          if (response.status === 200) {
            alert('그룹이 삭제 되었습니다.')
            setRowDetail('')
            getGroupListByLocation()
          }
          console.log('deleteGroup response.data:', response.data)
        } catch (e) {
          alert('그룹이 삭제 되지 않았습니다.')
          console.log('deleteGroup exception', e)
        }
      }
    } else {
    }
  }

  const patchGroup = async () => {
    // console.log("patchGroup rowDetail:",rowDetail)
    if (
      rowDetail !== undefined &&
      rowDetail !== null &&
      rowDetail !== '' &&
      props.data !== undefined &&
      props.data !== null &&
      props.data !== '' &&
      inputGroupMidModify !== undefined &&
      inputGroupMidModify !== null &&
      inputGroupMidModify !== '' &&
      inputGroupMidModify.length > 0
    ) {
      const tempObject = {
        grp_name: rowDetail.grp_name,
        grp_type: rowDetail.grp_type,
        grp_loid: props.data,
        grp_category: inputGroupCategoryModify,
        mid: inputGroupMidModify,
      }

      try {
        const response = await Api.patch('/api/v1/grp', tempObject)

        if (response.status === 200) {
          console.log('patchGroup ok tempObject:', tempObject)
          alert('그룹이 수정 되었습니다.')
          handleModifyGroupFlagFalse()
          getGroupListByLocation()
        }
        console.log('patchGroup response.data:', response.data)
      } catch (e) {
        alert(`그룹이 수정되지 않았습니다. ${e}`)
        console.log('patchGroup exception', e)
      }
    } else {
      alert('그룹이 선택되지 않았습니다.')
    }
  }

  const postGroup = async () => {
    if (
      inputGroupName !== undefined &&
      inputGroupName !== null &&
      inputGroupName !== '' &&
      inputGroupType !== undefined &&
      inputGroupType !== null &&
      inputGroupType !== '' &&
      props.data !== undefined &&
      props.data !== null &&
      props.data !== '' &&
      inputGroupMid !== undefined &&
      inputGroupMid !== null &&
      inputGroupMid !== '' &&
      inputGroupMid.length > 0
    ) {
      const tempObject = {
        grp_name: inputGroupName,
        grp_type: inputGroupType,
        grp_loid: props.data,
        grp_category: inputGroupCategory,
        mid: inputGroupMid,
      }
      console.log('post ok tempObject:', tempObject)
      try {
        const response = await Api.post('/api/v1/grp', tempObject)

        if (response.status === 200) {
          alert('그룹이 생성되었습니다.')
          handleNewGroupFlagFalse()
          getGroupListByLocation()
        }
        console.log('postGroup response.data:', response.data)
      } catch (e) {
        alert(`그룹이 생성되지 않았습니다. ${e}`)
        console.log('postGroup exception', e)
      }
    } else {
      alert('빈칸이 있거나 장비가 선택되지 않았습니다.')
    }
  }

  return (
    <div>
      <Grid container>
        <Grid size={7.5} sx={[styles1.grid2, { padding: 2 }]}>
          <Grid size={12}>
            <Typography sx={[styles1.Typography1, { fontSize: 18 }]}>장비 그룹 리스트</Typography>
          </Grid>
          <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <Button variant="contained" sx={styles1.button1} onClick={() => handleNewGroupFlagTrue()}>
              새그룹 생성
            </Button>
          </Grid>
          <Grid size={12} sx={{ marginTop: 1 }}>
            <Paper>
              <MantineReactTable table={table} />
            </Paper>
          </Grid>
        </Grid>
        <Grid size={0.5} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {/* <img style={{ height: 30, width: 30 }} src={arrow_detail}></img> */}
        </Grid>
        <Grid size={4} sx={[styles1.grid2, { padding: 2 }]}>
          {rowDetail ? (
            <div>
              {' '}
              <Grid container spacing={1.5}>
                <Grid size={12}>
                  <Box
                    sx={{
                      background: '#2F2E41',
                      width: 125,
                      height: 30,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Typography sx={[styles1.Typography1, { fontSize: 18 }]}>그룹세부정보</Typography>
                  </Box>
                </Grid>
                <Grid size={12}>
                  {/* mark */}
                  {modifyGroupFlag === false ? (
                    <div>
                      <Stack
                        direction="row"
                        spacing={1.5}
                        sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
                      >
                        <Button
                          variant="contained"
                          sx={[styles1.button1, { background: '#454546' }]}
                          onClick={() => handleModifyGroupFlagTrue()}
                        >
                          수정
                        </Button>
                        <Button
                          variant="contained"
                          sx={[styles1.button1, { background: '#454546' }]}
                          onClick={() => {
                            deleteGroup()
                          }}
                        >
                          삭제
                        </Button>
                      </Stack>
                    </div>
                  ) : (
                    <div>
                      <Stack
                        direction="row"
                        spacing={1.5}
                        sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
                      >
                        <Button
                          variant="contained"
                          sx={[styles1.button1, { background: '#454546' }]}
                          onClick={() => patchGroup()}
                        >
                          저장
                        </Button>
                        <Button
                          variant="contained"
                          sx={[styles1.button1, { background: '#454546' }]}
                          onClick={() => handleModifyGroupFlagFalse()}
                        >
                          취소
                        </Button>
                      </Stack>
                    </div>
                  )}
                </Grid>
                <Grid size={12}>
                  <Stack
                    direction="row"
                    spacing={1.5}
                    sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
                  >
                    <Typography sx={[styles1.Typography1, { fontSize: 15 }]}>그룹명</Typography>
                    <Box sx={styles1.Box1}>
                      <Typography sx={[styles1.Typography2, { fontSize: 15 }]}>{rowDetail.grp_name}</Typography>
                    </Box>
                  </Stack>
                </Grid>
                <Grid size={12}>
                  <Stack
                    direction="row"
                    spacing={1.5}
                    sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
                  >
                    <Typography sx={[styles1.Typography1, { fontSize: 15 }]}>용도</Typography>
                    {modifyGroupFlag === false ? (
                      <>
                        <Box sx={styles1.Box1}>
                          <Typography sx={[styles1.Typography2, { fontSize: 15 }]}>{rowDetail.grp_category}</Typography>
                        </Box>
                      </>
                    ) : (
                      <InputTextField
                        sx={[styles1.Select1, { width: 223 }]}
                        value={inputGroupCategoryModify}
                        onChange={handleInputGroupCategoryModify}
                      ></InputTextField>
                    )}
                  </Stack>
                </Grid>
                <Grid size={12}>
                  <Stack
                    direction="row"
                    spacing={1.5}
                    sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
                  >
                    <Typography sx={[styles1.Typography1, { fontSize: 15 }]}>등록일자</Typography>
                    <Box sx={styles1.Box1}>
                      {' '}
                      <Typography sx={[styles1.Typography2, { fontSize: 15 }]}>{rowDetail.ct}</Typography>
                    </Box>
                  </Stack>
                </Grid>
                {modifyGroupFlag === false ? (
                  <>
                    <Grid size={12}>
                      <Stack
                        direction="row"
                        spacing={1.5}
                        sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
                      >
                        <Typography sx={[styles1.Typography1, { fontSize: 15 }]}>포함장비리스트</Typography>
                        <Box sx={{ width: 323 }}></Box>
                      </Stack>
                      {rowDetail.mid.map((item, index) => {
                        return (
                          <Grid size={12} key={index} sx={{ marginBottom: 1 }}>
                            <Stack
                              direction="row"
                              spacing={1.5}
                              sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
                            >
                              <Box sx={[styles1.Box1]}>
                                <Typography sx={[styles1.Typography2, { fontSize: 15 }]}>{item.mname}</Typography>
                              </Box>
                            </Stack>
                          </Grid>
                        )
                      })}
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid size={12}>
                      <Stack
                        direction="row"
                        spacing={1.5}
                        sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
                      >
                        <Typography sx={[styles1.Typography1, { fontSize: 15 }]}>장비유형</Typography>
                        <Select
                          sx={[styles1.Select1, { width: 223 }]}
                          value={inputGroupType}
                          onChange={handleInputGroupType}
                        >
                          <MenuItem value={'Device'}>Device</MenuItem>
                          <MenuItem disabled value={'User'}>
                            User
                          </MenuItem>
                          <MenuItem disabled value={'Worker'}>
                            Worker
                          </MenuItem>
                          <MenuItem disabled value={'Facility'}>
                            Facility
                          </MenuItem>
                        </Select>
                      </Stack>
                    </Grid>
                    <Grid size={12}>
                      <Box sx={{ height: 370, width: '100%' }}>
                        <DataGrid
                          getRowId={(row) => row.di}
                          sx={styles1.DataGrid1}
                          rows={locationInfo}
                          columns={columnsDevice}
                          initialState={{
                            pagination: {
                              paginationModel: {
                                pageSize: 10,
                              },
                            },
                          }}
                          pageSizeOptions={[10]}
                          checkboxSelection
                          disableRowSelectionOnClick
                          onRowSelectionModelChange={(item) => setInputGroupMidModify(item)}
                        />
                      </Box>
                    </Grid>
                  </>
                )}
              </Grid>
            </div>
          ) : (
            <Typography sx={[styles1.Typography1, { fontSize: 15 }]}>데이터 선택 없음</Typography>
          )}
        </Grid>
      </Grid>
      {/* 그룹생성 다이아로그 */}

      <Dialog
        fullScreen={fullScreen}
        open={newGroupFlag}
        onClose={handleNewGroupFlagFalse}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent
          sx={{
            background: '#2F2E41',
          }}
        >
          <Grid container spacing={1.5} sx={{ padding: 3 }}>
            <Grid size={12}>
              <Box
                sx={{
                  marginTop: -2,
                  marginLeft: -2.5,
                  background: 'rgba(191, 191, 191, 0.062) 5.98%',
                  width: 94,
                  height: 49,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Typography sx={[styles1.Typography1, { fontSize: 20 }]}>그룹생성</Typography>
              </Box>
            </Grid>

            <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
              <Stack
                direction="row"
                spacing={3}
                sx={{ width: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                {/* mark */}
                <Typography sx={[{ fontSize: 15, color: '#ffffff', width: 80 }]}>그룹명</Typography>
                <TextField
                  sx={[
                    styles1.Select1,
                    {
                      width: 1,
                    },
                  ]}
                  value={inputGroupName}
                  onChange={handleInputGroupName}
                ></TextField>
              </Stack>
            </Grid>
            <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
              <Stack
                direction="row"
                spacing={3}
                sx={{ width: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <Typography sx={[{ fontSize: 15, color: '#ffffff', width: 80 }]}>용도</Typography>
                <TextField
                  sx={[styles1.Select1, { width: 1 }]}
                  value={inputGroupCategory}
                  onChange={handleInputGroupCategory}
                ></TextField>
              </Stack>
            </Grid>
            {/* <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
              <Stack
                direction="row"
                spacing={1.5}
                sx={{ width: 330, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <Typography sx={[{ fontSize: 15, color: '#ffffff' }]}>시설ID</Typography>
                <Box sx={{ border: '1px solid #CCCCCC', width: 223, height: 50, color: '#CCCCCC' }}>{props.data}</Box>
              </Stack>
            </Grid> */}
            <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
              <Stack
                direction="row"
                spacing={3}
                sx={{ width: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <Typography sx={[{ fontSize: 15, color: '#ffffff', width: 80 }]}>장비유형</Typography>
                {/* //"User", "Worker", "Device", "Facility" */}
                <Select sx={[styles1.Select1, { width: 1 }]} value={inputGroupType} onChange={handleInputGroupType}>
                  <MenuItem value={'Device'}>Device</MenuItem>
                  <MenuItem disabled value={'User'}>
                    User
                  </MenuItem>
                  <MenuItem disabled value={'Worker'}>
                    Worker
                  </MenuItem>
                  <MenuItem disabled value={'Facility'}>
                    Facility
                  </MenuItem>
                </Select>
              </Stack>
            </Grid>
            <Grid size={12}>
              <Box sx={{ height: 370, width: '100%' }}>
                <DataGrid
                  getRowId={(row) => row.di}
                  sx={styles1.DataGrid1}
                  rows={locationInfo}
                  columns={columnsDevice}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 10,
                      },
                    },
                  }}
                  pageSizeOptions={[10]}
                  checkboxSelection
                  disableRowSelectionOnClick
                  onRowSelectionModelChange={(item) => setInputGroupMid(item)}
                />
              </Box>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: '#2F2E41',
          }}
        >
          <Button
            variant="contained"
            sx={[styles1.button1, { background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',marginRight:1,marginBottom:3 }]}
            onClick={() => postGroup()}
          >
            생성
          </Button>
          <Button
            variant="contained"
            sx={[styles1.button1, { background: '#454546',marginBottom:3 }]}
            onClick={() => handleNewGroupFlagFalse()}
          >
            취소
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
